module.exports = __webpack_public_path__ + "img/Bell Red.eddbcdc7.svg";